import { GradeScaleSaveButton } from '@/components/features/grade-scale';
import { QUIZ_OPTIONS_FORM_ID, useQuizBuilder } from '@/context/quiz-builder';

export default function QuizBuilderSettingsSaveButton() {
  const { optionsForm } = useQuizBuilder();

  return (
    <GradeScaleSaveButton
      formId={QUIZ_OPTIONS_FORM_ID}
      getGradeMapping={() => optionsForm.getValues('gradeMapping')}
      setGradeMapping={(gradeMapping) => optionsForm.setValue('gradeMapping', gradeMapping, { shouldDirty: true })}
    />
  );
}
